import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
    addDeleteTransactionOptions: ['itemData', 'category'],
    getTransactionOptions: ['transactionToken', 'category', 'handleOpen'],
    handleError: ['error'],
    loadQuoteSuccess: ['quote'],
    resetItemValidation: [],
    setReadOnly: ['isReadOnly'],
    updateItemValidation: ['itemValidation'],
    updatePaymentOptionsSuccess: ['response'],
    updateTaxesIncluded: ['hasTaxesIncluded'],
    updateTransactionDetailsSuccess: ['response'],
    updateTransactionOptionsSuccess: ['options'],
    updateSelectedTab: ['tab'],

    changeCashDownAmount: ['value'],
    changeTradeInAmount: ['value'],
    changeLienAmount: ['value'],
    changePaymentFrequency: ['value'],

    changePaymentOptions: ['options'],

    // Actions that have Sagas
    applyCancelTransactionOption: ['transactionToken'],
    changeDesiredApr: ['calculationTargetValue'],
    changeDesiredPayment: ['targetType', 'value'],
    changePlan: ['financePlan', 'purchaseMethod', 'isSelected', 'index'],
    changeSelectedQuote: ['vehicle'],
    initializeStore: ['token', 'lang', 'queryParams', 'serverRuntimeConfig'],
    refreshQuote: [],
    selectCashPlan: [],
    selectPayment: ['cashDown', 'term', 'index'],
    selectPlan: ['index'],
    transactionAmountValidation: ['itemData'],
    transactionPrint: [],
    updateProfitRoll: ['targetType', 'value'],
    updateQuoteInformation: ['options'],

});
